import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import NavMenu from "./components/NavMenu";
import LoginModal from "../component/LoginModal";
import RegisterModal from "../component/RegisterModal";
import ForgotPassword from "../component/ForgotPassword";
export default function Header(props) {
  const { isAuthenticated } = useContext(AuthContext);
  useEffect(() => {
    if (isAuthenticated) {
      try {
        $("#sign_up_popup2").modal("hide");
        $("#sign_up_popup3").modal("hide");
        $(".modal-backdrop").remove();
        $("body").removeClass("modal-open");
        $("body").removeAttr("style");
      } catch (error) {
        // console.log(error);
      }
    }
  }, [isAuthenticated]);
  return (
    <React.Fragment>
      <header className="site-header header-style-3 fixed mobile-sider-drawer-menu">
        <div className="sticky-header main-bar-wraper  navbar-expand-lg is-fixed">
          <div className="main-bar">
            <div className="container clearfix">
              <div className="logo-header">
                <div className="logo-header-inner logo-header-one">
                  <Link to={"/"}>
                    <img src="portal/images/CompanyLogo.png" alt=""></img>
                  </Link>
                </div>
              </div>
              <NavMenu />
            </div>
          </div>
        </div>
      </header>
      {!isAuthenticated ? (
        <React.Fragment>
          <LoginModal />
          <RegisterModal />
          <ForgotPassword />
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
}
